import Joi from 'joi-browser';

const dayWorkerFormSchema = Joi.object().keys({
  admin_updated_at: Joi.date().allow(null, ''),
  created_at: Joi.date().allow(null, ''),
  create_admin_id: Joi.number().allow(null, ''),
  create_user_id: Joi.number().allow(null, ''),
  dayworker: Joi.string().allow(''),
  dayworker_type: Joi.number(),
  deleted_at: Joi.date().allow(null, ''),
  field_id: Joi.number(),
  id: Joi.number(),
  updated_at: Joi.date().allow(null, ''),
  update_admin_id: Joi.number().allow(null, ''),
  update_user_id: Joi.number().allow(null, ''),
  work_id: Joi.number(),
  working_temp_hour: Joi.number(),
  working_temp_person: Joi.string()
    .required()
    .disallow(''),
});

export default dayWorkerFormSchema;



// WEBPACK FOOTER //
// ./src/utilities/validationSchemas/dayWorker.js